import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { GroupSelectProvider, useGroupSelectContext } from '../context';
import { TGroupSelectProps, TSingleValue } from '../types';
import { multiToSingle, singleToMulti } from '../utils';
import { GroupsList } from './groups-list';
import { OptionsList } from './options-list';

function GroupSelect({ onChange, isMulti, mui, onGroupChange }: TGroupSelectProps) {
  const { values, shouldDirty, selectedGroup } = useGroupSelectContext();

  useEffect(() => {
    if (isMulti) {
      onChange(values);
    } else {
      const singleValue = multiToSingle(values);

      // @ts-ignore
      onChange(singleValue, shouldDirty);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMulti, values, shouldDirty]);

  useEffect(() => {
    onGroupChange?.(selectedGroup);
  }, [selectedGroup]);

  return (
    <Stack direction="row" width={mui?.width ?? '100%'} overflow="hidden" {...mui}>
      <GroupsList />

      <OptionsList />
    </Stack>
  );
}

/**
 * Component that renders two level select. At first you have to select group and then you will see options of that group.
 * The height of the component is determined by the mui.height prop or if not passed by the height of all group items
 */
export default function GroupSelectWrapper<TGroupName extends string = string>(props: TGroupSelectProps<TGroupName>) {
  const value = props.isMulti ? props.value : singleToMulti(props.value as TSingleValue<TGroupName>);

  return (
    <GroupSelectProvider value={value} isMulti={props.isMulti} groups={props.groups}>
      <GroupSelect {...props} />
    </GroupSelectProvider>
  );
}
